module.exports = __webpack_public_path__ + "img/new-info-icon.77e8f4e5.svg";